// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/navigation/workspace/app/css/app.css
// module id = 768
// module chunks = 0